import { createContext, useContext, useEffect, useMemo, useState } from 'react';

/* ================================
 * User 타입 정의 (필요에 맞게 확장)
 * ================================ */
export interface User {
  id: string;
  name: string;
  email?: string;
  role?: string;
}

/* ================================
 * Context 타입 정의
 * ================================ */
interface AuthContextType {
  user: User | null;
  setUser: (user: User | null) => void;
}

/* ================================
 * Context 생성
 * ================================ */
const AuthContext = createContext<AuthContextType | undefined>(undefined);

/* ================================
 * Provider Props
 * ================================ */
interface AuthProviderProps {
  children: React.ReactNode;
}

/* ================================
 * Provider 구현
 * ================================ */
const AuthProvider = ({ children }: AuthProviderProps) => {
  const [user, setUser] = useState<User | null>(null);

  useEffect(() => {
    // 예: localStorage / token 기반 자동 로그인 처리
    // const storedUser = ...
    // setUser(storedUser);
  }, []);

  const contextValue = useMemo<AuthContextType>(
    () => ({
      user,
      setUser
    }),
    [user]
  );

  return <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>;
};

/* ================================
 * Custom Hook
 * ================================ */
export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }

  return context;
};

export default AuthProvider;
